import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg viewBox="0 0 427.492 440.158" ref={svgRef} {...props}>
    <title>
      Illustration of MetLife heart, paper and pencil, and mail
    </title>
    <defs>
      <style>
        {`.cls-1{fill:#0090da}.cls-2{fill:#a4ce4e}.cls-3{fill:#f2f2f2}.cls-4{fill:#d9d9d6}.cls-5{fill:#a7a8aa}.cls-7{fill:#fff}`}
      </style>
      <clipPath id="heart-clip-path">
        <rect x="0" y="0" width="220" height="187" />
      </clipPath>
      <clipPath id="blue-paper-clip-path">
        <rect x="0" y="0" width="115" height="160" />
      </clipPath>
    </defs>
    <g id="Group_1587" data-name="Group 1587" transform="translate(-846 -201.333)">
      <g id="heart" data-name="Group 689" transform="translate(1043.048 201.321)" clipPath="url(#heart-clip-path)">
        <path
          id="heart-blue-half"
          data-name="Path 216"
          className="cls-1"
          d="M212.14,88.63A52,52,0,0,1,285.59,15l.31.32L303.41,33l-.21,149.5Z"
          transform="translate(-197 0)"
        />
        <path id="heart-green-half" data-name="Path 217" className="cls-2"
          d="M139.878 15.408a52.119 52.119 0 0 0-73.548-.219L48.6 32.7v149.5l91.06-93.463c20.357-19.919 20.357-52.972.219-73.329"
          transform="translate(57.767 .119)"
        />
      </g>
      <g id="Group_690" data-name="Group 690" transform="translate(846 326.598)" >
        <g id="gray-paper" data-name="Group 645">
          <g id="Group_644" data-name="Group 644">
            <path
              id="Path_195"
              data-name="Path 195"
              className="cls-3"
              d="M0 43.577v180.536h168.085V0H43.577z"
            />
            <path
              id="Path_196"
              data-name="Path 196"
              className="cls-4"
              d="M43.577 0v43.577H0z"
            />
            <g
              id="Group_643"
              data-name="Group 643"
              transform="translate(31.588 63.176)"
            >
              <path
                id="Rectangle_284"
                data-name="Rectangle 284"
                className="cls-5 gray-text"
                d="M0 0h105.139v6.917H0z"
              />
              <path
                id="Rectangle_282"
                data-name="Rectangle 282"
                className="cls-5 gray-text"
                transform="translate(0 20.982)"
                d="M0 0h105.139v6.917H0z"
              />
              <path
                id="Rectangle_283"
                data-name="Rectangle 283"
                className="cls-5 gray-text"
                transform="translate(0 41.963)"
                d="M0 0h105.139v6.917H0z"
              />
              
              <path
                id="Rectangle_285"
                data-name="Rectangle 285"
                className="cls-5 gray-text"
                transform="translate(0 62.945)"
                d="M0 0h105.139v6.917H0z"
              />
              <path
                id="Rectangle_286"
                data-name="Rectangle 286"
                className="cls-5 gray-text"
                transform="translate(0 83.927)"
                d="M0 0h105.139v6.917H0z"
              />
              <path id="Rectangle_287" data-name="Rectangle 287" className="cls-5 gray-text" transform="translate(0 104.909)" d="M0 0h49.111v6.917H0z" />
            </g>
          </g>
        </g>
        <g
          id="Group_648"
          data-name="Group 648"
          transform="translate(101.45 82.774)"
        >
          <g
            id="Group_646"
            data-name="Group 646"
            transform="translate(0 28.36)"
          >
            <path
              id="Path_197"
              data-name="Path 197"
              d="M52.7 116.448L122.793 48.2z"
              transform="translate(-32.641 -48.2)"
              fill="none"
            />
          </g>
          <g id="blue-pencil" data-name="Group 647" transform="translate(2.306)">
            <path
              id="Path_199"
              data-name="Path 199"
              className="cls-7"
              d="M62.77 82.853L53.317 73.4 46.4 92.768 49.628 96z"
              transform="translate(-43.172 13.063)"
            />
            <path
              id="Path_200"
              data-name="Path 200"
              className="cls-4"
              d="M60.942 77.5l9.458 9.453-19.6 6.917-3-3.228z"
              transform="translate(-41.344 18.417)"
            />
            <path
              id="Rectangle_288"
              data-name="Rectangle 288"
              className="cls-1"
              transform="rotate(45 17.25 103.872)"
              d="M0 0h13.373v96.608H0z"
            />
            <path
              id="Rectangle_289"
              data-name="Rectangle 289"
              transform="rotate(45 10.52 119.966)"
              fill="#0061a0"
              d="M0 0h13.373v96.608H0z"
            />
            <path
              id="Path_201"
              data-name="Path 201"
              className="cls-5"
              d="M45 91.253l3.228-9.453 3.228 3.228 3 3.228z"
              transform="translate(-45 24.031)"
            />
            <path
              id="Rectangle_290"
              data-name="Rectangle 290"
              className="cls-3"
              transform="rotate(45 29.468 108.783)"
              d="M0 0h13.373v9.914H0z"
            />
            <path
              id="Rectangle_291"
              data-name="Rectangle 291"
              transform="rotate(45 22.747 124.884)"
              fill="#ffc600"
              d="M0 0h13.373v9.914H0z"
            />
            <path
              id="Path_202"
              data-name="Path 202"
              className="cls-2"
              d="M110.129 46.737l-8.762-8.762a7.237 7.237 0 0 0-10.145 0L82 47.2l18.907 18.9 9.223-9.223a7.236 7.236 0 0 0-.001-10.14z"
              transform="translate(3.31 -35.9)"
            />
          </g>
        </g>
      </g>
      <g id="Group_1074" data-name="Group 1074" transform="translate(1091 459)">
        <g clipPath="url(#blue-paper-clip-path)">
          <path
            id="blue-paper"
            data-name="Rectangle 442"
            fill="#218ece"
            d="M0 0h114.151v159.586H0z"
          />
          <path
            id="Path_309"
            data-name="Path 309"
            className="cls-7 text-2 text-2--gray"
            d="M80.075 30.505H8.73a4.167 4.167 0 0 1-4.13-4.13V11.73A4.167 4.167 0 0 1 8.73 7.6h71.345a4.167 4.167 0 0 1 4.13 4.13V26a4.262 4.262 0 0 1-4.13 4.506"
            transform="translate(12.673 20.938)"
          />
          <path
            id="Path_310"
            data-name="Path 310"
            className="cls-7 text-2 text-2--gray"
            d="M80.075 38.53H8.73A4.167 4.167 0 0 1 4.6 34.4V20.13A4.167 4.167 0 0 1 8.73 16h71.345a4.167 4.167 0 0 1 4.13 4.13V34.4a4.167 4.167 0 0 1-4.13 4.13"
            transform="translate(12.673 44.079)"
          />
          <path
            id="Path_311"
            data-name="Path 311"
            className="text-2 text-2--blue"
            d="M80.075 46.93H8.73A4.167 4.167 0 0 1 4.6 42.8V28.53a4.167 4.167 0 0 1 4.13-4.13h71.345a4.167 4.167 0 0 1 4.13 4.13V42.8a4.167 4.167 0 0 1-4.13 4.13"
            transform="translate(12.673 67.221)"
            fill="#a4ce4b"
          />
        </g>
        <g id="envelope">
          <path
            id="Rectangle_443"
            data-name="Rectangle 443"
            className="cls-4"
            transform="translate(45.435 102.511)"
            d="M0 0h137.056v79.981H0z"
          />
          <path
            id="Path_312"
            data-name="Path 312"
            d="M12.2 27.3l68.34 51.443L148.881 27.3z"
            transform="translate(33.611 75.211)"
            fill="#f2f2f3"
          />
        </g>
        
      </g>
    </g>
  </svg>
)

const BeneficiarySVG = React.forwardRef((props, ref) => (
    <SvgComponent svgRef={ref} {...props} />
  ))
  
  export default BeneficiarySVG
